/* eslint-disable no-unused-vars */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Helmet } from 'react-helmet';

import { downloadWelcomePackService } from
  '../../account/components/AccountTab/components/OrderFull/store/service';
import * as basketActions from '../../basket/store/actions';
import { getIsEligibleForHomePickup } from '../../basket/store/selectors';
import { paymentTypes } from '../../../config/types';
import { getMessage, getPaymentType, getIsCollectionArranged } from '../store/selectors';
import { getActiveDiscountCode } from '../../get-paid/store/selectors';
import * as confirmOrderActions from '../store/actions';
import * as getPaidActions from '../../get-paid/store/actions';
import PaperLayout from '../../../components/PaperLayout/PaperLayout';
import {
  OrderData,
  ArrangeCollection,
  CollectionArranged
} from '../components';
import Stepper from '../../../components/Stepper/Stepper.js';
import { VOUCHER, VOUCHER_INCREASE } from '../../../config/constants';
import { Button, PostcodeWithMap } from '../../../components';
import history from '../../../services/history';
import styles from './styles';
import { getPrice } from '../../../services/priceHelper';

class ChooseDeliveryPage extends React.Component {
  state = {};

  componentDidMount() {
    const id = JSON.parse(localStorage.getItem('CartID'));
    this.props.requestBasket(id, true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isEligibleForHomePickup
      && prevProps.isEligibleForHomePickup !== this.props.isEligibleForHomePickup) {
      const isEligibleForHomePickupFromStorage = JSON.parse(
        localStorage.getItem('isEligibleForHomePickup')
      );
      this.props.setIsEligibleForHomePickup(isEligibleForHomePickupFromStorage);
    }
  }

  componentWillUnmount() {
    this.props.setMessage({ status: null, message: null });
    this.props.resetActiveDiscountCode();
  }

  onPressWelcomePack = () => {
    const CustomerId = localStorage.getItem('loggedID');
    const Token = localStorage.getItem('token');
    const total = JSON.parse(localStorage.getItem('total'));
    const downloadWelcomePackLink = downloadWelcomePackService({
      CustomerId,
      Token,
      OrderId: total.orderId,
    });
    return downloadWelcomePackLink;
  }

  onComplete = () => {
    history.push({
      pathname: '/account/orders',
      state: { from: 'parcel-shop' }
    });
  }

  render() {
    const {
      classes,
      isCollectionArranged,
      isEligibleForHomePickup,
      activeDiscountCode
    } = this.props;
    const helper = `We have emailed you your Welcome Pack which contains FREEPOST labels 
    and your three nearest Evri stores to give your box(es) to. Once you drop it off, 
    we should receive it within 2 - 3 working days and we’ll pay you within 7 days of 
    receiving your stuff.`;
    const welcomePackText = 'You can also download your welcome pack by ';
    const welcomePackTextForTrade = 'You can download your welcome pack by ';
    const welcomePackLink = 'clicking here';
    const total = JSON.parse(localStorage.getItem('total'));
    const tradeCustomer = JSON.parse(localStorage.getItem('TradeCustomer'));

    return (
      <PaperLayout
        hasBackButton={false}
        hasSubPaper={false}
        label={'THANK FOR YOUR ORDER'}
      >
        <Helmet>
          <script>
            {/*  eslint-disable-next-line no-undef */}
            {gtag('event', 'conversion', { send_to: 'AW-658456431/v5SFCMDxtsoBEO_-_LkC' })}
          </script>
        </Helmet>
        <OrderData
          payment={paymentTypes[this.props.paymentType]}
          price={this.props.paymentType === VOUCHER
            ? getPrice(activeDiscountCode, total, true)
            : getPrice(activeDiscountCode, total)}
          orderId={total.orderId}
        />
        {!tradeCustomer && <span className={classes.helperContainer}>{helper}</span>}
        <span className={classes.welcomePackContainer}>
          <span>{tradeCustomer ? welcomePackTextForTrade : welcomePackText}</span>
          <base target={'_blank'} />
          <MediaQuery minWidth={650}>
            {matches => (matches
              ? (
                <a className={classes.linkButton} href={this.onPressWelcomePack()}>
                  <span className={classes.welcomePackLink}>{welcomePackLink}</span>
                </a>)
              : (
                <a className={classes.linkButton} href={this.onPressWelcomePack()}>
                  <Button outlined text={'clicking here'} style={classes.button} />
                </a>)
            )}
          </MediaQuery>
        </span>
        <div className={classes.greenContainer}>
          <span>TIME TO SEND YOUR ORDER</span>
        </div>
        <span className={classes.titleText}>NEXT STEPS</span>
        {isEligibleForHomePickup && !tradeCustomer && (
          <div className={classes.arangeCollectionContainer}>
            {(isCollectionArranged ? <CollectionArranged /> : <ArrangeCollection />)}
          </div>
        )}
        { !isEligibleForHomePickup && (
          <>
            <Stepper isTradeCustomer={!!tradeCustomer} isArrangeCollection={false}>
              {isCollectionArranged ? <CollectionArranged /> : <ArrangeCollection />}
            </Stepper>
            {!tradeCustomer && <PostcodeWithMap />}
          </>
        )}
        <Button
          style={classes.completeButton}
          onPress={this.onComplete}
          text={'GO TO MY ORDERS'}
        />
      </PaperLayout>
    );
  }
}

ChooseDeliveryPage.propTypes = {
  classes: PropTypes.object,
  setMessage: PropTypes.func,
  paymentType: PropTypes.number,
  requestBasket: PropTypes.func,
  isCollectionArranged: PropTypes.bool,
  isEligibleForHomePickup: PropTypes.bool,
  setIsEligibleForHomePickup: PropTypes.func,
  activeDiscountCode: PropTypes.object,
  resetActiveDiscountCode: PropTypes.func
};

ChooseDeliveryPage.defaultProps = {
  classes: {},
  setMessage: () => { },
  paymentType: 4,
  requestBasket: () => { },
  isCollectionArranged: false,
  isEligibleForHomePickup: false,
  setIsEligibleForHomePickup: () => { },
  activeDiscountCode: {},
  resetActiveDiscountCode: () => { },
};

const mapStateToProps = (state) => {
  return {
    message: getMessage(state),
    paymentType: getPaymentType(state),
    isCollectionArranged: getIsCollectionArranged(state),
    isEligibleForHomePickup: getIsEligibleForHomePickup(state),
    activeDiscountCode: getActiveDiscountCode(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestBasket: (id, isChooseDeliv) => dispatch(basketActions.requestBasket(id, isChooseDeliv)),
    setMessage: message => dispatch(confirmOrderActions.setMessage(message)),
    setIsCollectionArranged: payload => dispatch(
      confirmOrderActions.setIsCollectionArranged(payload)
    ),
    setIsEligibleForHomePickup: isEligibleForHomePickup => dispatch(
      basketActions.setIsEligibleForHomePickup(isEligibleForHomePickup)
    ),
    resetActiveDiscountCode: () => dispatch(getPaidActions.resetActiveDiscountCode())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ChooseDeliveryPage));
